export default __webpack_public_path__ + "static/media/Martiyers8.df742681.jpg";